import React from "react";
import { graphql } from "gatsby";
import { getSrc } from "gatsby-plugin-image";
import LinkedInIcon from "../../assets/svgs/linkedin.svg";
import Layout from "../../components/Layout";
import "./about-us.scss";

import WithI18next from "../../components/WithI18next";
import { isTranslationEmpty } from "../../utils";

const MemberCard = ({ post, heading }) => {
  const Heading = heading || "h3";
  return (
    <div className="col-md-6 col-lg-4 mb-4 d-flex align-items-stretch">
      <div className="card">
        <a href={post.node.acfTeamMembers.tmLinkedinUrl} rel="noopener">
          <div className="mt-4 text-center tm-container">
            <img
              src={getSrc(
                post.node.acfTeamMembers.tmPicture.localFile.childImageSharp
                  .gatsbyImageData
              )}
              className="card-img-top tm-picture"
              alt=""
              width={116}
              height={116}
            />
            {post.node.acfTeamMembers.tmLinkedinUrl && (
              <LinkedInIcon className="tm-icon" width={30} height={30} />
            )}
          </div>

          <div className="card-body">
            <Heading
              className="text-center"
              dangerouslySetInnerHTML={{ __html: post.node.title }}
            />
            <p
              className="tm-designation"
              dangerouslySetInnerHTML={{
                __html: post.node.acfTeamMembers.tmDesignation,
              }}
            />
            <div
              className="card-text"
              dangerouslySetInnerHTML={{ __html: post.node.content }}
            />
          </div>
        </a>
      </div>
    </div>
  );
};

const AboutPage = ({ data, t }) => {
  return (
    <Layout
      title={t("aboutUs.seo.title")}
      description={t("aboutUs.seo.description")}
    >
      <div id="about-us" className="pt-5">
        {/* acf: before_team_members start */}
        {data.beforeTeamMembers.edges.map((post, i) => (
          <div
            id={post.node.slug}
            className="about-us__our-mission"
            key={`before_team_members-${i}`}
          >
            <div className="container py-5">
              <div dangerouslySetInnerHTML={{ __html: post.node.content }} />
            </div>
          </div>
        ))}
        {/* acf: before_team_members end */}

        {/* founders start */}
        <div id="team" className="container mt-5 py-5">
          {!isTranslationEmpty(t, "aboutUs.founder.groupExecutives") && (
            <h1 className="text-center mb-5">
              {t("aboutUs.founder.groupExecutives")}
            </h1>
          )}
          <h1 className="text-center mb-5">{t("aboutUs.founder.title")}</h1>
          <div className="row justify-content-center">
            {data.founders.edges.map((post, i) => (
              <MemberCard post={post} key={`founders-${i}`} />
            ))}
          </div>
        </div>
        {/* founders end */}

        {/* management start */}
        <div className="container py-5">
          <h1 className="text-center mb-5">{t("aboutUs.management.title")}</h1>
          <div className="row justify-content-center">
            {data.management.edges.map((post, i) => (
              <MemberCard post={post} key={`management-${i}`} heading="h4" />
            ))}
          </div>
        </div>
        {/* management end */}

        <hr className="my-5" />

        {/* acf: after_team_members start */}
        {data.afterTeamMembers.edges.map((post, i) => (
          <div
            id={post.node.slug}
            className="about-us__footer"
            key={`after_team_members-${i}`}
          >
            <div className="container py-5">
              <div dangerouslySetInnerHTML={{ __html: post.node.content }} />
            </div>
          </div>
        ))}
        {/* acf: after_team_members end */}
      </div>
    </Layout>
  );
};

export default WithI18next()(AboutPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    founders: allWpTeamMemberItem(
      filter: {
        acfTeamMembers: { tmType: { eq: "founders" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: DESC, fields: date }
    ) {
      edges {
        node {
          title
          content
          acfTeamMembers {
            tmDesignation
            tmPicture {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 600, layout: CONSTRAINED)
                }
              }
            }
            tmLinkedinUrl
          }
        }
      }
    }
    management: allWpTeamMemberItem(
      filter: {
        acfTeamMembers: { tmType: { eq: "management" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: DESC, fields: date }
    ) {
      edges {
        node {
          title
          content
          acfTeamMembers {
            tmDesignation
            tmPicture {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 600, layout: CONSTRAINED)
                }
              }
            }
            tmLinkedinUrl
          }
        }
      }
    }
    beforeTeamMembers: allWpComponentItem(
      filter: {
        acfComponents: { cApplySection: { eq: "before_team_members" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          title
          slug
          content
        }
      }
    }
    afterTeamMembers: allWpComponentItem(
      filter: {
        acfComponents: { cApplySection: { eq: "after_team_members" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          title
          slug
          content
        }
      }
    }
  }
`;
